export default "__VITE_ASSET__6ZXOutAX__"